import { render, staticRenderFns } from "./RemoteFn.vue?vue&type=template&id=69e0196c&scoped=true&"
import script from "./RemoteFn.vue?vue&type=script&lang=js&"
export * from "./RemoteFn.vue?vue&type=script&lang=js&"
import style0 from "./RemoteFn.vue?vue&type=style&index=0&id=69e0196c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e0196c",
  null
  
)

export default component.exports